import { Edit } from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import React from "react";
import ArrayToCSV from "../../../components/ArrayToCSV/ArrayToCSV";
function MaterialTable(props) {
  return (
    <MaterialReactTable
      displayColumnDefOptions={{
        "mrt-row-actions": {
          muiTableHeadCellProps: {
            align: "center",
          },
          size: 120,
        },
      }}
      columns={props.columns}
      data={props.tableData}
      editingMode="modal" //default
      enableColumnOrdering
      enableEditing
      onEditingRowSave={props.handleSaveRowEdits}
      onEditingRowCancel={props.handleCancelRowEdits}
      renderRowActions={({ row, table }) => (
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
          }}
        >
          <Tooltip arrow placement="left" title="Edit">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      renderTopToolbarCustomActions={() => (
        <>
          <ArrayToCSV data={props.tableData} csvFileName={props.csvFileName} />
          <Button
            onClick={() => props.setCreateModalOpen(true)}
            variant="contained"
          >
            Add New Supplier
          </Button>
          <Button
            onClick={() => props.setSubtractModalOpen(true)}
            style={{
              backgroundColor: "#1976D2",
              color: "white",
              marginLeft: "2rem",
            }}
            variant="contained"
          >
            Create Purchase Order
          </Button>
        </>
      )}
    />
  );
}

export default MaterialTable;
